const DIVISION_UPLOAD_URL = '/company/v1/division/upload';

const EMPTY_STATS = {
  total: 0,
  success: 0,
  duplicate: 0,
  fail: 0
};

const STATUS_MAP = {
  SUCCESS: 'success',
  DUPLICATE: 'duplicate',
  DUPLICATED: 'duplicate',
  FAIL: 'fail'
};
const MESSAGE_MAP = {
  success: '신규 등록 완료',
  duplicate: '이미 존재하는 부서'
};

function normalizeStats(count) {
  return {
    total: Number((count && count.total) || 0),
    success: Number((count && count.success) || 0),
    duplicate: Number((count && count.duplicate) || 0),
    fail: Number((count && count.fail) || 0)
  };
}

function normalizeStatus(status) {
  return STATUS_MAP[status] || '';
}

function normalizeMessage(status, failCause) {
  if (status === 'fail') return failCause || '';
  return MESSAGE_MAP[status] || '';
}

function createResultRow(result) {
  const departments = Array.isArray(result.path) ? result.path : [];
  const status = normalizeStatus(result.status);
  const row = {
    rowNumber: result.row,
    departments,
    status,
    message: normalizeMessage(status, result.failCause)
  };

  departments.forEach((department, index) => {
    row[`dept${index + 1}`] = department;
  });

  return row;
}

function normalizeDivisionUploadResponse(response) {
  const results = response && Array.isArray(response.results) ? response.results : [];
  const rows = results.map(createResultRow);
  const maxDepartmentDepth = rows.reduce((maxDepth, row) => Math.max(maxDepth, row.departments.length), 0);

  return {
    stats: response && response.count ? normalizeStats(response.count) : { ...EMPTY_STATS, total: rows.length },
    rows,
    maxDepartmentDepth
  };
}

export default {
  DIVISION_UPLOAD_URL,
  normalizeDivisionUploadResponse
};
